import React from 'react'
import About from './About.js';
import NavBar from './Navbar.js';
import logo from './img/logo.png'


export default class Contact extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      thanks: false,
      form: {
        Nombre: '',
        Email: '',
        Telefono: '',
        Direccion: '',
        Razon: '',
        Mensaje: ''
      }
    }
  }

  handleFieldChange = (formField) => {
    return (e) => {
      let state = { ...this.state };
      state.form[formField] = e.target.value;
      this.setState(state);
    }
  }

  encode = (data) => {
    return Object.keys(data)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`)
        .join('&');
  }

  submitForm = (event) => {
    event.preventDefault()
    this.setState({ isLoading: true })
    return fetch('/actions/enviar.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: this.encode({ 'form-name': 'Nuevo-Contacto', ...this.state.form })
    })
    .then(() => {
        window.gtag('event', 'aaa', {
            'event_category' : 'bbb',
            'event_label' : 'ccc'
          });
          return Promise.resolve()
    })
    .catch(err => console.error(err))
    .finally(() => this.setState({ isLoading: false, thanks: true }));
  }

  componentDidMount() {
    require('./js/maps.active.js')
    window.initMap()
    window.jqueryOnReady()
  }

  render() {
return (<div>
  <NavBar  pathName={this.props.location.pathname}></NavBar>
  <section  className="contact-area" id="contact">
    <div className="container">
    <div className="row" style={{     paddingTop: 150 }}>
      <div className="col-xs-12 col-md-4">
      <div className="area-title text-center wow fadeIn" style={{marginBottom: 0}}>
                    <img src={logo} alt="logo" />
                        <p style={{paddingTop: 50, textAlign: 'center'}}>
                        Gestión integral para importación y exportación para empresas y particulares. ¿Necesitas de nuestros servicios?
Contacta a Eduardo Callado por cualquiera de nuestros medios y él se pondrá en contacto a la brevedad.
                            </p>
                            <div className="single-footer-widget footer-about" style={{color: '#687284'}}>
                            <ul>
                            <li><i className="fa fa-phone"></i> <a href="callto:+54 351-4256230">+54 351-4256230</a></li>
                                <li><i className="fa fa-phone"></i> <a href="https://wa.me/5493518017757?text=Hola+Tcc+Argentina%2C%0D%0A%0D%0AEstoy+interesado+en+ponerme+en+contacto.">WhatsApp: +5493518017757</a></li>
                                <li><i className="fa fa-envelope"></i><a href="mailto:info@tcc-argentina.com.ar">info@tcc-argentina.com.ar</a></li>
                                <li><i className="fa  fa-map-marker"></i><span style={{ color: '#a1a7b2'}}>AV. EMILIO OLMOS 112 3º PISO - CÓRDOBA - ARGENTINA</span></li>
                            </ul>
                        </div>
                    </div>
      </div>
      <div className="col-xs-12 col-md-8 form-container">
      <div  className="contact-form">
      { this.state.thanks ? <div className="row">
        <div className="col-md-12" style={{ textAlign: 'center' }}>
          <h1>Gracias por su consulta</h1>
          <p>Responderemos su consulta a la brevedad</p>
        </div>
      </div>  : <form onSubmit={this.submitForm} >
              <div  className="row">
                  <div  className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                      <div  className="form-group" id="name-field">
                          <div  className="form-input">
                              <input required type="text"  className="form-control" id="form-name" name="Nombre" placeholder="Nombre y Apellido" value={this.state.Nombre} onChange={this.handleFieldChange('Nombre')} />
                          </div>
                      </div>
                  </div>
                  <div  className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                      <div  className="form-group" id="email-field">
                          <div  className="form-input">
                              <input type="email"  className="form-control" id="form-email" name="Email" placeholder="Email" required value={this.state.Email} onChange={this.handleFieldChange('Email')} />
                          </div>
                      </div>
                  </div>
              </div>
              <div  className="row">
                  <div  className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                      <div  className="form-group" id="phone-field">
                          <div  className="form-input">
                              <input type="text"  className="form-control" id="form-phone" name="Telefono" placeholder="Teléfono" value={this.state.Telefono} onChange={this.handleFieldChange('Telefono')} />
                          </div>
                      </div>
                  </div>
                  <div  className="col-md-6 col-lg-6 col-sm-12 col-xs-12">
                      <div  className="form-group" id="address-field">
                          <div  className="form-input">
                              <input type="text"  className="form-control" id="form-address" name="Direccion" placeholder="Dirección" value={this.state.Direccion} onChange={this.handleFieldChange('Direccion')} />
                          </div>
                      </div>
                  </div>
              </div>
              <div  className="row">
                  <div  className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                      <div  className="form-group" id="phone-field">
                          <div  className="form-input">
                              <input type="text"  className="form-control" id="form-phone" name="Razon" placeholder="Razón" value={this.state.Razon} onChange={this.handleFieldChange('Razon')} />
                          </div>
                      </div>
                  </div>
              </div>
              <div  className="row">
                  <div  className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                      <div  className="form-group" id="message-field">
                          <div  className="form-input">
                              <textarea  className="form-control" rows="6" id="form-message" name="Mensaje" placeholder="Su mensaje..." required value={this.state.Mensaje} onChange={this.handleFieldChange('Mensaje')}></textarea>
                          </div>
                      </div>
                  </div>
              </div>
              <div  className="row">
                  <div  className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                      <div  className="form-group">
                          <button disabled={this.state.isLoading} className="tcc-contact-button" type="submit">Enviar</button>
                      </div>
                  </div>
              </div>
          </form>}
          
      </div>
      </div>
    </div>
    </div>

    <div  className="map-area relative">
        <div id="map" style={{ width: '100%', height: 400 }}> </div>
    </div>
</section>
  </div>)
  }
}